<app-campaign-inventory-internal-search
  [selectedValue]="regionScreenSelectedValue.split('-')[0]"
></app-campaign-inventory-internal-search>
<br />
<!-- table data of national campaign inventory -->
<div>
  <div class="ag-theme-balham">
    <div content style="display: flex" class="scroll-div">
      <div style="flex: 1">
        <ag-grid-angular
          class="grid-settings ag-theme-density zebra ag-theme-bmw ag-theme-balham grid-struct ag-theme-quartz"
          [rowHeight]="40"
          [rowData]="rowData"
          [style.height.px]="dynamicTableHeight"
          [overlayNoRowsTemplate]="noRowsTemplate"
          [cacheBlockSize]="30"
          [columnDefs]="columns"
          [pagination]="true"
          [rowSelection]="'multiple'"
          [theme]="theme"
          (rowClicked)="onRowClicked($event)"
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector"
          [rowBuffer]="50"
          [defaultColDef]="defaultColDef"
          [headerHeight]="50"
          (gridReady)="onGridReady($event)"
          [gridOptions]="gridOptions"
          (paginationChanged)="onPaginationChanged()"
          (filterChanged)="onMarketFilterChanged()"
          (gridSizeChanged)="onGridSizeChanged()"
        >
        </ag-grid-angular>
        <br />
      </div>
    </div>
  </div>
  <ds-box>
    <div
      class="action-bar"
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
      "
    >
      <div class="backNavigationButton">
        <ds-button tone="action" size="lg" (click)="goToNationalPage()"
          >National List</ds-button
        >
        <ds-button tone="action" size="lg" (click)="goToRegionalPage()"
          >Regional List</ds-button
        >
      </div>
      <div
        class="actions-right"
        style="display: flex; align-items: center; gap: 0.5rem"
      >
        <h3 class="title-sm" style="margin: 0">Export:</h3>
        <ds-button style="margin-right: 2px" (click)="windowPrint()">
          <ds-icon icon="file_pdf" size="lg" tone="action"></ds-icon>
        </ds-button>
      </div>
    </div>
  </ds-box>
</div>
